import { useTheme } from "next-themes";
import { getChartProps, getStatusColors } from "../config/chart-config";

/**
 * Hook that provides theme-aware chart configurations and utilities
 */
export const useChartTheme = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return {
    isDark,
    statusColors: getStatusColors(isDark),
    chartProps: getChartProps(isDark),
  };
};
